<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle || $route.meta.identificativo"
    class="content-header"
  >
    <b-col class="content-header-left" cols="12"  md="12" >
      <b-row class="breadcrumbs-top">
        <b-col cols="6">
          <h2 id="contenedor_identificativo" class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.identificativo }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
        <b-col cols="6">
          <div
              id="contenedor-botones"
              style="margin-left: 30%"
            >
              <b-row>
              <b-col cols="2">
                <b-link v-if="$route.meta.accion1" :to="$route.meta.accion1.url">
                    <b-button
                      variant="primary"
                      size="sm"
                      style="margin-right: 0%"
                    >
                       Crear
                    </b-button>
                  </b-link>
              </b-col>
              <b-col cols="2">
                <b-button
                      v-if="$route.meta.excel"
                      id="btn-excel" 
                      variant="primary"
                      @click="doExcelAction()"
                      ref="btnexcel"
                      size="sm"
                      style="margin-right: 0%; background: #37ef00!important; border-color: #37ef00!important;"
                    >
                      <i class="fas fa-file-excel"></i>
                  </b-button>
              </b-col>
              <b-col cols="2">
                <b-button
                            v-if="$route.meta.pdf"
                            id="btn-pdf" 
                            variant="danger"
                            @click="doPdfAction()"
                            ref="btnpdf"
                            size="sm"
                            style="margin-right: 0%"
                            >
                                Pdf
                </b-button>
              </b-col>
            </b-row>
            </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from "@/libs/axios";
import $ from 'jquery'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BLink,
  },
  created() {
    this.setToken()
  },
  methods: {
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },
    doExcelAction() {
      this.$emit('fetch-excel');
    },
    doPdfAction() {
      this.$emit('fetch-pdf');
    },
  },
}
</script>
